<template>
  <div>
    <TitlePage :title="$t('create')+' '+$t('adminCenter')"></TitlePage>

    <v-layout wrap>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="form.full_name" :rules="validation.textRules" :error-messages="errors.full_name"></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="form.email" :rules="validation.email"  :error-messages="errors.email"></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-select label="Ruolo" v-model="form.role" :rules="validation.textRules"  :error-messages="errors.role" :items="roles"></v-select>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password_new')" v-model="form.password_new"
                      :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword2 ? 'text' : 'password'"
                      @click:append="showPassword2 = !showPassword2" :error-messages="errors.password_new"
        ></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password_new_confirm')" v-model="form.password_new_confirm"
                      :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword3 ? 'text' : 'password'"
                      @click:append="showPassword3 = !showPassword3" :rules="validation.passwordMatch" :error-messages="errors.password_new_confirm"
        ></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-switch v-model="form.active" inset :label="$t('status')"></v-switch>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <CenterAutocomplete @message="setCenterId"></CenterAutocomplete>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";

export default {
  name: "CreateCenterAdmin",
  components: {CenterAutocomplete, TitlePage},
  data() {
    return {
      check: true,
      showPassword2:false,
      showPassword3:false,
      roles: [
        {text:'Gestore Centro Sportivo',value:'admin'},
        {text:'Collaboratore',value:'collaborator'},
      ],
      form:{
        active: false,
        full_name: '',
        email: '',
        password_new: '',
        password_new_confirm: '',
        center_id: '',
        role: ''
      },
      errors:{
        full_name: '',
        email: '',
        password_new: '',
        password_new_confirm: '',
        role: ''
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        email: [
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || this.$t('emailNotValid')
          }
        ],
        passwordMatch:[
          v => v == this.form.password_new || this.$t('password_not_match')
        ]
      }
    };
  },
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    })
  },
  async created(){
    if(!this.getUser.super_admin){
      this.$router.push('/')
      return
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'centerAdmin/centerAdminStore'
    }),
    async save(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.storeItem(this.form)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        await this.$router.push('/center-admin/')

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result.response.data)
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.form.full_name){
        this.check = false
        this.errors.full_name = this.$t('fillMandatory');
      }

      if(!this.form.email){
        this.check = false
        this.errors.email = this.$t('fillMandatory');
      }

      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!pattern.test(this.form.email)){
        this.check = false
        this.errors.email = this.$t('emailNotValid');
      }

      if(!this.form.role){
        this.check = false
        this.errors.role = this.$t('fillMandatory');
      }


      if(this.form.password_new != '' || this.form.password_new_confirm != ''){

        if(!this.form.password_new){
          this.check = false
          this.errors.password_new = this.$t('fillMandatory');
        }

        if(!this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('fillMandatory');
        }

        if(this.form.password_new != this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('password_not_match');
        }

      }

    },
    async resetError(){
      this.errors = {
        full_name: '',
        email: '',
        password_new: '',
        password_new_confirm: '',
        role: '',
      }
    },

    setCenterId(id){
      this.form.center_id = id
    }

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>